// src/pages/orcamentos/OrcamentoItemModal.js
import React, { useEffect, useState } from 'react';
import Input from '../../components/input/Input';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalHeader from '../../components/modalForm/ModalHeader';
import { useMessage } from '../../contexts/geral/MessageContext';
import { useProduto } from '../../contexts/produtos/ProdutoContext';
import { formatNumeric, normalizeDecimalInputBr, parseNumeric } from '../../utils/numberUtils';
import ProdutoCad from '../produtos/produtos/ProdutoCad';

const vazio = { produtoId: 0, descricao: '', xProd: '', alteraDescricao: false, quantidade: '1,00', valorUnitario: '0,00', valorDesconto: '0,00', observacao: '' };

const OrcamentoItemModal = ({ show, item, onHide, onSave }) => {
  const [dados, setDados] = useState(vazio);
  const [showProduto, setShowProduto] = useState(false);
  const { produtos, showProdutoSearch } = useProduto();
  const { showMessage } = useMessage();

  useEffect(() => {
    if (show) setDados(item ? {
      ...item,
      quantidade: formatNumeric(item.quantidade ?? 1),
      valorUnitario: formatNumeric(item.valorUnitario ?? 0),
      valorDesconto: formatNumeric(item.valorDesconto ?? 0),
    } : { ...vazio });
  }, [show, item]);

  const alterar = (campo, valor) => setDados(anterior => ({ ...anterior, [campo]: valor }));
  const selecionar = produto => {
    if (!produto) return;
    setDados(anterior => ({ ...anterior, produtoId: produto.id, descricao: produto.descricao, xProd: produto.descricao, alteraDescricao: Boolean(produto.alteraDescricao), valorUnitario: formatNumeric(produto.preco || 0), tipo: produto.ehServico ? 2 : 1 }));
  };
  const buscar = async () => selecionar(await showProdutoSearch());
  const validarCodigo = () => {
    if (!dados.produtoId) return;
    const produto = produtos.find(x => Number(x.id) === Number(dados.produtoId));
    if (produto) selecionar(produto);
    else { showMessage('Produto ou serviço não encontrado.', 'warning'); alterar('produtoId', 0); }
  };
  const total = Math.max(parseNumeric(dados.quantidade) * parseNumeric(dados.valorUnitario) - parseNumeric(dados.valorDesconto), 0);
  const salvar = () => {
    if (parseNumeric(dados.valorUnitario) <= 0) {
      showMessage('Informe um valor unitário maior que zero.', 'warning');
      return;
    }

    onSave({ ...dados, quantidade: parseNumeric(dados.quantidade), valorUnitario: parseNumeric(dados.valorUnitario), valorDesconto: parseNumeric(dados.valorDesconto) });
  };

  return <>
    <ModalContainer show={show} largura="650px">
      <ModalHeader><h5>{item ? 'Alterar item do orçamento' : 'Adicionar item ao orçamento'}</h5><button type="button" className="btn-close" onClick={onHide} /></ModalHeader>
      <ModalBody>
        <div className="d-flex flex-wrap align-items-end gap-2">
          <Input label="Código" value={dados.produtoId || ''} disabled={Boolean(dados.id)} size={100} btnBuscar={dados.id ? null : buscar} btnAdd={dados.id ? null : () => setShowProduto(true)} onChange={e => alterar('produtoId', e.target.value.replace(/\D/g, ''))} onBlur={validarCodigo} />
          <Input label="Descrição do produto ou serviço" value={dados.xProd || ''} disabled={!dados.alteraDescricao} size={430} onChange={e => alterar('xProd', e.target.value)} />
        </div>
        <div className="d-flex flex-wrap align-items-end gap-3 mt-2">
          {['quantidade', 'valorUnitario', 'valorDesconto'].map(campo => <Input key={campo} label={{ quantidade: 'Quantidade', valorUnitario: 'Valor unitário', valorDesconto: 'Desconto' }[campo]} value={dados[campo]} size={110} style={{ textAlign: 'right' }} onChange={e => alterar(campo, normalizeDecimalInputBr(e.target.value))} onBlur={() => alterar(campo, formatNumeric(dados[campo]))} />)}
          <Input label="Total" value={formatNumeric(total)} disabled size={110} />
        </div>
        <div className="mt-2"><Input label="Observação" value={dados.observacao || ''} rows={2} size="100%" onChange={e => alterar('observacao', e.target.value)} /></div>
      </ModalBody>
      <ModalFooter><button type="button" className="btn btn-secondary" onClick={onHide}>Cancelar</button><button type="button" className="btn btn-primary" disabled={!dados.produtoId || !dados.xProd?.trim()} onClick={salvar}>Salvar</button></ModalFooter>
    </ModalContainer>
    <ProdutoCad show={showProduto} onHide={() => setShowProduto(false)} onSaveProduto={produto => { selecionar(produto); setShowProduto(false); }} />
  </>;
};

export default OrcamentoItemModal;
